const initState = {
    complianceStandards: [],
    compliance_id: null,
    compliance: null,
    procedures: [],
    actions: [],
    newlyCreatedComplianceId: null,
    compliance_dashboard_data: null,
    activeComplianceId: null,
    actions_data: [],
    finding_data: [],
};

const complianceReducer = (state = initState, action) => {
    switch (action.type) {
        case "SET_ACTIVE_COMPLIANCE":
            ////////console.log("reducer action:",action);
            return {
                ...state,
                activeComplianceId: action.compliance_id,
            };

        case "OPEN_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: action.compliance_id,
            };

        case "RESET_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: null,
            };

        case "PROCEDURES":
            return {
                ...state,
                procedures: action.complianceStandards,
            };

        case "COMPLIANCE_ACTIONS":
            return {
                ...state,
                actions: action.actions,
            };

        case "UPDATE_COMPLIANCE_STANDARD":
            return {
                ...state,
                compliance: action.compliance,
            };

        case "RESET_NEWLYCREATED_COMPLIANCE_ID":
            return {
                ...state,
                newlyCreatedComplianceId: null,
            };

        case "COMPLIANCE_CREATED":
            ////console.log("Here")
            return {
                ...state,
                complianceStandards: action.complianceStandards,
                newlyCreatedComplianceId: action.newlyCreatedComplianceId,
            };

        case "COMPLIANCE_STANDARDS":
            ////console.log("Here 2 ", action.complianceStandards)
            return {
                ...state,
                complianceStandards: action.complianceStandards,
            };
            
         case "ACTIONS_DATA_COMP":
            return {
                ...state,
                actions_data: action.actions,
            };

         case "FINDINGS_DATA":
            return {
                ...state,
                finding_data: action.findings,
            };

        case "COMPLIANCE_STANDARD_DELETE":
            return {
                ...state,
                complianceStandards: state.complianceStandards.filter(
                    (c) => c.compliance_id !== action.id
                ),
                activeComplianceId: state.activeComplianceId === action.id? null : state.activeComplianceId
            };

        default:
            return state;
    }
};

export default complianceReducer;